


































































































































































import Api from "@/api/Api";
import JwtToken from "@/api/JwtToken";
import DeleteAdvertiserButton from "@/components/Button/DeleteAdvertiserButton.vue";
import ResetPasswordButton from "@/components/Button/ResetPasswordButton.vue";
import Vue from "vue";
import { Advertiser } from "../../../interfaces/advertiser";
import { UserLogin } from "../../../interfaces/userlogin";
export default Vue.extend({
  components: { ResetPasswordButton, DeleteAdvertiserButton },
  computed: {
    filterParams(): { [key: string]: string } {
      const params = {} as { [key: string]: string };
      if (this.filters.id) {
        params["id"] = "" + this.filters.id;
      }

      if (this.filters.companyName) {
        params["companyName"] = "" + this.filters.companyName;
      }

      if (this.filters.personInCharge) {
        params["personInCharge"] = "" + this.filters.personInCharge;
      }

      if (this.filters.ownerEmail) {
        if (this.filters.ownerEmail) {
          params["owner.email"] = this.filters.ownerEmail;
        }
      }

      return params;
    },
  },
  data(): {
    isLoading: boolean;
    advertisers: Advertiser[];
    userLogins: { [key: string]: UserLogin };
    deleting?: Advertiser;
    filters: { [key: string]: string };
  } {
    return {
      isLoading: true,
      advertisers: [],
      userLogins: {},
      deleting: undefined,
      filters: {},
    };
  },
  methods: {
    modifyQuery(query: Record<string, string | number>) {
      if (this.filters.id) {
        query["id"] = "" + this.filters.id;
      }

      if (this.filters.companyName) {
        query["companyName"] = "" + this.filters.companyName;
      }

      if (this.filters.personInCharge) {
        query["personInCharge"] = "" + this.filters.personInCharge;
      }

      if (this.filters.ownerEmail) {
        if (this.filters.ownerEmail) {
          query["owner.email"] = this.filters.ownerEmail;
        }
      }

      return query;
    },
    loadingStateChange(state: unknown) {
      this.isLoading = !!state;
    },
    async setAutoConfirmable(advertiser: Advertiser) {
      if (
        !confirm(
          "クライアントID " + advertiser.id + "の広告自動承認を設定します"
        )
      ) {
        return;
      }
      await Api.singleton().call({
        method: "PUT",
        resource: advertiser["@id"] + "/auto_confirmable",
      });

      advertiser.isAutoConfirmable = true;
    },
    async unsetAutoConfirmable(advertiser: Advertiser) {
      if (
        !confirm(
          "クライアントID " + advertiser.id + "の広告自動承認を解除します"
        )
      ) {
        return;
      }
      await Api.singleton().call({
        method: "DELETE",
        resource: advertiser["@id"] + "/auto_confirmable",
      });

      advertiser.isAutoConfirmable = false;
    },
    async switchUser(email: string) {
      const res = await Api.singleton().call({
        method: "POST",
        resource: "/api/adv/switch_user",
        query: {
          to: email,
        },
      });

      JwtToken.singleton().setImpersonatedJwtToken(res.token);
      JwtToken.singleton().saveImpersonatedRefreshToken(res.refresh_token);

      this.$router.push({
        name: "AdvertiserIndex",
      });
    },
  },
});
